import React, { useState, useEffect } from 'react';

import '../css/modal.css';

const DataModal = ({ data, title, isOpen, onRequestClose }) => {
  // Get column headers dynamically
  const headers = data?.length > 0 ? Object.keys(data[0]) : [];

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content  ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body ">
            {data && data.length > 0 ? (
              <div className="table-responsive">
                <table className="data-table">
                  <thead className="thead-dark">
                    <tr>
                      {headers
                        .filter((header) => header.toLowerCase() !== 'color')
                        .map((header) => (
                          <th key={header}>{header.toUpperCase()}</th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          item.color
                            ? `row-color-${item.color.trim().toLowerCase()}`
                            : ''
                        }
                      >
                        {headers
                          .filter((header) => header.toLowerCase() !== 'color')
                          .map((key) => (
                            <td key={key}>
                              {item[key]?.includes('<a') ? '' : item[key]}
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>Loading...</p>
            )}

            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={onRequestClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataModal;
